export const AnnualReportPrice = 990
